export const MATERIALS_PREFIX = "@MATERIALS/"
export const FETCH_MATERIALS = `${MATERIALS_PREFIX}FETCH_MATERIALS`

export const MATERIAL_GROUPS_PREFIX = "@MATERIAL_GROUPS/"
export const FETCH_MATERIAL_GROUPS = `${MATERIALS_PREFIX}FETCH_MATERIAL_GROUPS`
